import { gql } from '@apollo/client';

export const UPDATE_CRM_PIPELINE = gql`
    mutation UpdateCrmPipeline($input: UpdateCrmPipelineInput!) {
        updateCrmPipeline(input: $input) {
            _id
            stages {
                key
                name
                order
                color
                isWon
                isLost
                statuses {
                    label
                    fromDays
                    toDays
                    color
                }
            }
        }
    }
`;
